import React, { useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { Redirect } from "react-router";
import { RouteComponentProps } from "react-router";
import { bindActionCreators, Dispatch } from "redux";
import styled from "styled-components";
import { NewUser } from "sweet-global";
import Button from "sweet-web/components/universal/Button";
import OutlineButton from "sweet-web/components/universal/Button/OutlineButton";
import Input from "sweet-web/components/universal/Input";
import LocationInput from "sweet-web/components/universal/Input/LocationInput";
import PhoneNumberInput from "sweet-web/components/universal/Input/PhoneNumberInput";
import SingleImageInput from "sweet-web/components/universal/Input/SingleImageInput";
import { Label, Title } from "sweet-web/components/universal/Text";
import { Form } from "sweet-web/components/universal/View";
import { colors } from "sweet-web/lib/styles";
import { RootState } from "sweet-web/redux";
import * as selectors from "sweet-web/redux/selectors";
import { CreateUser } from "sweet-web/redux/user/actions";

const WrongJoinType = styled.div`
  margin: 15px 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const InputRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

type Props = ConnectedProps<typeof connector> & RouteComponentProps;

const initialUser: NewUser = {
  firstName: "",
  lastName: "",
  phoneNumber: "",
  emailAddress: "",
  image: "",
  type: "USER",
  location: null
};

const Join: React.FC<Props> = props => {
  const { loggedIn, loading } = props;

  const [user, setUser] = useState(initialUser);
  const [password, setPassword] = useState("");

  if (loggedIn) {
    return <Redirect to="/" />;
  }

  const onSubmit = e => {
    e.preventDefault();
    props.CreateUser(user, password);
  };

  return (
    <Form onSubmit={onSubmit} style={{ marginTop: "5%" }}>
      <Title>Join Sweet</Title>

      <WrongJoinType>
        <Label>
          Trying to join as a venue
          <br />
          owner or manager?
        </Label>
        <OutlineButton
          title="List your venue"
          onClick={() => props.history.push("/list")}
        />
      </WrongJoinType>

      <InputRow>
        <Input
          title={"First Name"}
          value={user.firstName}
          style={{ flex: 1, marginRight: 5 }}
          onChange={value => {
            setUser({
              ...user,
              firstName: value
            });
          }}
        />

        <Input
          title={"Last Name"}
          value={user.lastName}
          style={{ flex: 1, marginLeft: 5 }}
          onChange={value => {
            setUser({
              ...user,
              lastName: value
            });
          }}
        />
      </InputRow>

      <Input
        title={"Email"}
        value={user.emailAddress}
        onChange={value => {
          setUser({
            ...user,
            emailAddress: value
          });
        }}
      />

      <PhoneNumberInput
        value={user.phoneNumber}
        onChange={value => {
          setUser({
            ...user,
            phoneNumber: value
          });
        }}
      />

      <LocationInput
        location={user.location}
        placeholder="City"
        onLocationChange={location => {
          setUser({
            ...user,
            location
          });
        }}
      />

      <Input
        title={"Password"}
        type={"password"}
        value={password}
        onChange={value => {
          setPassword(value);
        }}
      />

      <Button submit={true} loading={loading} title="Get Started" />
    </Form>
  );
};

const mapState = (state: RootState) => ({
  loggedIn: selectors.loggedIn(state),
  loading: selectors.isAuthenticating(state) || selectors.isCreatingUser(state)
});
const mapDispatch = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      CreateUser
    },
    dispatch
  );
const connector = connect(mapState, mapDispatch);

export default connector(Join);
